// Trial lesson form: classroom tab, student card block, admin section.
const dict = {
  uk: {
    tab: 'Анкета',
    tabTooltip: 'Анкета пробного заняття (видно лише вам і адміну)',
    intro: 'Заповнюйте під час уроку. Анкета зберігається автоматично, а після завершення уроку буде надіслана адміну і з’явиться в картці учня.',
    saving: 'Зберігаємо…',
    saved: 'Збережено',
    saveError: 'Не вдалося зберегти',
    loadError: 'Не вдалося завантажити анкету',
    submitted: 'Надіслано адміну',
    emptyReminder: 'Анкета пробного заняття порожня. Заповніть її у вкладці «Анкета» перед завершенням уроку.',
    fields: {
      level: 'Рівень англійської',
      age: 'Вік / клас',
      experience: 'Попередній досвід вивчення',
      interests: 'Інтереси, улюблені теми',
      strengths: 'Сильні сторони',
      weaknesses: 'Над чим працювати',
      personality: 'Характер, як працює на уроці',
      goals: 'Цілі учня / побажання батьків',
      recommended_program_id: 'Рекомендована програма',
      recommended_frequency: 'Рекомендована частота',
      student_liked: 'Чи сподобалось учню',
      notes: 'Додаткові нотатки',
    },
    placeholders: {
      age: 'напр. 9 років, 3 клас',
      experience: 'Де і скільки вчив(-ла), чи був репетитор…',
      interests: 'Ігри, тварини, Minecraft, футбол…',
      strengths: 'Що виходить добре',
      weaknesses: 'Вимова, граматика, словниковий запас…',
      personality: 'Активний, сором’язливий, швидко втомлюється…',
      goals: 'Навіщо вчить, що хочуть батьки',
      notes: 'Все інше, що варто знати адміну',
    },
    levelNone: '— не визначено —',
    programNone: '— не обрано —',
    frequency: { '1': '1 раз на тиждень', '2': '2 рази на тиждень', '3': '3 рази на тиждень' },
    liked: { yes: 'Так', maybe: 'Скоріше так', no: 'Ні' },
    // Student card
    cardTitle: 'Анкета пробного заняття',
    cardTitleMany: 'Анкети пробних занять',
    cardEmptyForm: 'Вчитель не заповнив анкету',
    lessonOn: 'Пробне {{date}}',
    byTeacher: 'Вчитель: {{name}}',
    // Admin
    adminTitle: 'Пробні заняття',
    adminSubtitle: 'Анкети, які вчителі заповнили на пробних заняттях. Відмічайте, що зроблено з кожним учнем.',
    filterAll: 'Усі',
    allTeachers: 'Усі вчителі',
    noForms: 'Анкет поки немає',
    status: { new: 'Нова', contacted: 'Зв’язались', purchased: 'Купив', declined: 'Відмовився' },
    student: 'Учень',
    teacher: 'Вчитель',
    lessonDate: 'Дата пробного',
    contacts: 'Контакти',
    parent: 'Батьки',
    adminComment: 'Коментар адміна',
    adminCommentPlaceholder: 'Що сказали батьки, коли передзвонити…',
    saveComment: 'Зберегти коментар',
    updatedBy: 'Оновив(-ла) {{name}}, {{date}}',
    close: 'Закрити',
    updateError: 'Не вдалося оновити',
  },
  en: {
    tab: 'Form',
    tabTooltip: 'Trial lesson form (visible only to you and admins)',
    intro: 'Fill it in during the lesson. It saves automatically; when the lesson ends it is sent to the admin and attached to the student card.',
    saving: 'Saving…',
    saved: 'Saved',
    saveError: 'Could not save',
    loadError: 'Could not load the form',
    submitted: 'Sent to admin',
    emptyReminder: 'The trial lesson form is empty. Fill it in on the “Form” tab before ending the lesson.',
    fields: {
      level: 'English level',
      age: 'Age / grade',
      experience: 'Previous learning experience',
      interests: 'Interests, favourite topics',
      strengths: 'Strengths',
      weaknesses: 'Areas to work on',
      personality: 'Personality, behaviour in class',
      goals: 'Student goals / parent wishes',
      recommended_program_id: 'Recommended program',
      recommended_frequency: 'Recommended frequency',
      student_liked: 'Did the student enjoy it',
      notes: 'Additional notes',
    },
    placeholders: {
      age: 'e.g. 9 years old, 3rd grade',
      experience: 'Where and how long they studied, tutors…',
      interests: 'Games, animals, Minecraft, football…',
      strengths: 'What goes well',
      weaknesses: 'Pronunciation, grammar, vocabulary…',
      personality: 'Active, shy, gets tired quickly…',
      goals: 'Why they learn, what parents want',
      notes: 'Anything else the admin should know',
    },
    levelNone: '— not set —',
    programNone: '— not selected —',
    frequency: { '1': 'Once a week', '2': 'Twice a week', '3': '3 times a week' },
    liked: { yes: 'Yes', maybe: 'Mostly yes', no: 'No' },
    cardTitle: 'Trial lesson form',
    cardTitleMany: 'Trial lesson forms',
    cardEmptyForm: 'The teacher did not fill in the form',
    lessonOn: 'Trial on {{date}}',
    byTeacher: 'Teacher: {{name}}',
    adminTitle: 'Trial lessons',
    adminSubtitle: 'Forms teachers filled in during trial lessons. Track what was done with each student.',
    filterAll: 'All',
    allTeachers: 'All teachers',
    noForms: 'No forms yet',
    status: { new: 'New', contacted: 'Contacted', purchased: 'Purchased', declined: 'Declined' },
    student: 'Student',
    teacher: 'Teacher',
    lessonDate: 'Trial date',
    contacts: 'Contacts',
    parent: 'Parent',
    adminComment: 'Admin comment',
    adminCommentPlaceholder: 'What the parents said, when to call back…',
    saveComment: 'Save comment',
    updatedBy: 'Updated by {{name}}, {{date}}',
    close: 'Close',
    updateError: 'Could not update',
  },
};

export default dict;
